import type { WorkspaceDocument } from '~/types/models';

export function normalizeDocumentTags(tags: string[]): string[] {
    const normalized = tags
        .map(tag => String(tag || '').trim())
        .filter(Boolean)
        .map(tag => tag.slice(0, 40));
    return Array.from(new Set(normalized)).slice(0, 12);
}

export function workspaceDocumentMatchesQuery(document: WorkspaceDocument, query: string): boolean {
    const needle = String(query || '').trim().toLowerCase();
    if (!needle) return true;
    const plainContent = String(document.content || '').replace(/<[^>]+>/g, ' ');
    return [
        document.title,
        plainContent,
        document.projectName,
        document.clientName,
        document.folderName,
        ...(document.tags || []),
    ].some(value => String(value || '').toLowerCase().includes(needle));
}
